module.exports = __webpack_public_path__ + "img/wash.01638893.png";